export default "__VITE_ASSET__RySENTvG__"